// context/UserContext.js

import React, { createContext, useState, useEffect, useRef } from 'react'

export const UserContext = createContext()

export function UserProvider({ children }) {
  const [userData, setUserData] = useState(null)
  const [loadingUserData, setLoadingUserData] = useState(true)
  const logoutTimer = useRef(null)

  function logout() {
    setUserData(null)
    localStorage.removeItem('userData')
    localStorage.removeItem('token')
    window.location.href = '/login'
  }

  function schedule(token) {
    if (!token) return
    const { exp } = JSON.parse(atob(token.split('.')[1]))
    const diff = exp * 1000 - Date.now()
    if (diff <= 0) logout()
    else {
      clearTimeout(logoutTimer.current)
      logoutTimer.current = setTimeout(logout, diff)
    }
  }

  useEffect(() => {
    const stored = localStorage.getItem('userData')
    const token = localStorage.getItem('token')
    if (stored && token) {
      setUserData(JSON.parse(stored))
      schedule(token)
    }
    setLoadingUserData(false)
  }, [])

  const setUserAndStore = (data, token) => {
    setUserData(data)
    localStorage.setItem('userData', JSON.stringify(data))
    schedule(token)
  }

  return (
    <UserContext.Provider value={{ userData, setUserAndStore, logout, loadingUserData }}>
      {children}
    </UserContext.Provider>
  )
}